import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TextField } from 'src/components/Form';
import { isThaiMoney } from 'src/utils/CustomValidators';
import TargetSettings from './TargetSettings';

const AllowanceDeductionFixed = ({ payrollRuleGroup }) => {
  const { t } = useTranslation();
  const isSemiMonthlyPayment = payrollRuleGroup?.paymentCount === 'twice';
  return (
    <div>
      {isSemiMonthlyPayment ? (
        <>
          <TextField
            label={t('features.ClientAllowances.components.AllowanceEditingForm.amount_first_half')}
            name="allowanceAmount"
            yen
            required
            validate={isThaiMoney}
          />
          <TextField
            label={t('features.ClientAllowances.components.AllowanceEditingForm.amount_second_half')}
            name="allowanceAmountSecondHalf"
            yen
            required
            validate={isThaiMoney}
          />
        </>
      ) : (
        <TextField
          label={t('features.ClientAllowances.components.AllowanceEditingForm.amount')}
          name="allowanceAmount"
          yen
          required
          validate={isThaiMoney}
        />
      )}
      <TargetSettings allowanceType="deduction" />
    </div>
  );
};

export default connect()(AllowanceDeductionFixed);
